import React from 'react';

import { SKELETON_TYPES } from '@interlayer/js/app/components/main/Skeleton/constants';
import { TDetailedWithTitleProps } from '@interlayer/js/app/components/main/Skeleton/types';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import style from './DetailedWithTitle.scss';
import styleScroller from '@interlayer/js/app/components/common/Scroller/Scroller.scss';
import styleDetailedTile from '@interlayer/js/app/components/main/Games/components/GameTile/components/DetailedTile/DetailedTile.scss';

export const DetailedWithTitle: React.FC<TDetailedWithTitleProps> = ({ type, rows = 1 }) => {
    return (
        <>
            {type === SKELETON_TYPES.allCategory && (
                <div className={style.titleWrapper}>
                    <div className={style.title} />

                    <div className={style.link} />
                </div>
            )}

            <div className={styleScroller.scrollContainer}>
                {Array.from({ length: rows }, (_, index) => (
                    <div key={index} className={clsx(styleScroller.container, style.container)}>
                        {Array.from({ length: 5 }, (__, indexItem) => (
                            <div
                                key={indexItem}
                                className={clsx(style.item, styleDetailedTile.gameTile, styleDetailedTile.isInlineMode)}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
};
